export default "__VITE_ASSET__DqXOflOk__"